import { AppLocale } from '@procsea/common/utils'
import { CountryCode } from '@procsea/design-system'

import { COUNTRY_CODES, APP_LANGUAGES as LANGS } from 'src/constants/constants'

interface Language {
  label: string
  flag: CountryCode
}

export const APP_LANGUAGES: Record<AppLocale, Language> = {
  [AppLocale.EN]: { label: LANGS[AppLocale.EN], flag: COUNTRY_CODES[AppLocale.EN] },
  [AppLocale.FR]: { label: LANGS[AppLocale.FR], flag: COUNTRY_CODES[AppLocale.FR] },
  [AppLocale.DE]: { label: LANGS[AppLocale.DE], flag: COUNTRY_CODES[AppLocale.DE] },
  [AppLocale.IT]: { label: LANGS[AppLocale.IT], flag: COUNTRY_CODES[AppLocale.IT] },
}
